import { RootState } from "./store";

export const selectGraphTimeLimits = (state: RootState) => {
  return state.graph.time.limits;
};

export const selectSelectedTime = (state: RootState) => {
  return state.graph.time.selected;
};

export const selectSensorDataUpdatedAt = (state: RootState) => {
  return state.graph.dataUpdatedAt;
};

export const selectIsRunLive = (state: RootState) => {
  return state.graph.isRunLive;
};

export const selectActiveElement = (state: RootState) => {
  return state.graph.activeElement;
};

export const selectCurrentTags = (state: RootState) => {
  return state.graph.tags;
};

export const selectIsTagging = (state: RootState) => {
  return state.graph.isTagging;
};

export const selectGraphTooltip = (state: RootState) => {
  return state.graph.tooltip;
};

export const selectGraphTime = (state: RootState) => {
  return state.graph.time;
};

export const selectYAxisVisibility = (state: RootState) => {
  return state.graph.yAxisVisibility;
};

export const selectToleranceTag = (state: RootState) => {
  return state.graph.toleranceTag;
};

export const selectGraphSettings = (state: RootState) => {
  return state.graph.settings;
};

export const selectShowStandBy = (state: RootState) => {
  return state.graph.settings.showStandBy;
};

export const selectShowAlarms = (state: RootState) => {
  return state.graph.settings.showAlarms;
};

export const selectShowSelfTests = (state: RootState) => {
  return state.graph.settings.showSelfTests;
};

export const selectRunTypeSentAt = (state: RootState) => {
  return state.graph.runTypeSentAt;
};

export const selectIsZoomed = (state: RootState) => {
  return state.graph.isZoomed;
};

export const selectIsEmptyRun = (state: RootState) => {
  return state.graph.isEmptyRun;
};
